module.exports = __webpack_public_path__ + "static/media/detail11.84975d5e.svg";